// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/mobile/OnboardScreen.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/mobile/pink/OnboardScreen.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/mobile/mheader.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blue_bg{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 340px;
    width: 100%;
}
.pink .blue_bg{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 340px;
    width: 100%;
}

 /* nav.navbar {
    display: none;
}  */
.app_logo{
    color:#fff;
    font-size: 26px;
    font-family: 'Montserrat', sans-serif !important;
    font-weight: 700;
    margin-top: 10px;
    text-align: center;
}
/* .loginpage {
    font-family: 'Montserrat', sans-serif !important;
    margin-top: -88px;
    width: 100%;
    margin-left: -11px;
    margin-right: -11px;
    position: absolute;
} */

.loginpage {
    font-family: 'Montserrat', sans-serif !important;
    width: 100%;
    position: absolute;
} 

.login_form p{
    font-family: 'Montserrat', sans-serif !important;
}
.mvbutton{
background-color: #4565AD !important;
height:60px;
font-size: 20px!important;
font-family: 'Montserrat', sans-serif !important;
font-weight: 600  !important;
text-transform: capitalize !important;
}
.mobile_inp{
    text-align: center !important;
    font-size: 18px!important;
font-family: 'Montserrat', sans-serif !important;
font-weight: 500  !important;

}
.mobile_inp input.MuiOutlinedInput-input{
    text-align: center !important;
    font-size: 18px!important;
    font-family: 'Montserrat', sans-serif !important;
font-weight: 700  !important;
color:#000 !important;
}
.login_form {
    border-radius: 30px;
}
.mdfixed-top {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1030;
}

.plisttext{
    font-weight: 700 !important;
    font-size: 18px !important;
    padding-top:11px !important;
    font-family: 'Montserrat', sans-serif !important;
}
.patientslist .MuiListItemText-primary{
    text-transform: uppercase !important;
    font-weight: 700 !important;
    font-size: 13px !important;
    font-family: 'Montserrat', sans-serif !important;
}

.editbutton{
    background-color: #4565AD !important;   
    font-size: 10px!important;
    font-family: 'Montserrat', sans-serif !important;
    font-weight: 600  !important;
    }
.no-text{  
    font-size: 16px!important;
    font-family: 'Montserrat', sans-serif !important;
    font-weight: 500  !important;  

}
.edit-form-label{
    font-size: 16px!important;
    font-family: 'Montserrat', sans-serif !important;
    font-weight: 600  !important;  
}
.sinput-border{
    font-size: 16px!important;
    font-family: 'Montserrat', sans-serif !important;
    font-weight: 500  !important;  
}
.bbtn{
    text-transform:'capitalize';
    font-family: 'Montserrat', sans-serif !important;
    font-weight: 600  !important;  
    /* background-color: #4565AD !important; */
    height: 50px;
    color:#fff;
}
.cbtn{
    text-transform:'capitalize';
    font-family: 'Montserrat', sans-serif !important;
    font-weight: 600  !important;  
   /* background-color: #D9D9D9  !important; */
    /* color:#000 !important; */
    height: 50px !important;
}

.blueheader{
    background-color: #4565AD;
    color:#fff;
    margin: -10px;
    border-radius: 10px 10px 0px 0px;
}

.blueheader p{
    color:#fff;
    font-family: 'Montserrat', sans-serif !important;
    font-weight: 500  !important;  
    font-size: 16px!important;
    padding-top: 10px;
    margin-bottom: 9px;
}

.in_bluerow{
    padding: 5px 10px;
}

.mgenter_class .MuiFormControlLabel-root{
    margin-right: 5px !important;
    font-family: 'Montserrat', sans-serif !important;
}
.mgenter_class{
    margin-left: 0px !important;
    font-family: 'Montserrat', sans-serif !important;
}
.mgenter_class .MuiFormControlLabel-label,#datein{
    font-family: 'Montserrat', sans-serif !important;
}

.editpatientslist .MuiFormHelperText-root,.addpatientslist.MuiFormHelperText-root{
    font-family: 'Montserrat', sans-serif !important;
}


.mgenter_class .css-rgrmo-MuiButtonBase-root-MuiRadio-root.Mui-checked {
    color:#4565AD !important;
}


/* Splash screen css */
.splash-screen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    transition: opacity 0.5s ease-in-out;
  }
  
  .splash-screen.hidden {
    opacity: 0;
    visibility: hidden;
  }
  
  .splash-screen.visible {
    opacity: 1;
    visibility: visible;
  }
.sp_loader{
    position:absolute;
    margin-top: 100px;
}
@media (max-width: 980px) {
    .mdfixed-top{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
    }
    .css-1g7nc1s-MuiPickersLayout-root .MuiPickersLayout-actionBar {
            display: none;
    }
}


#pink .btn-primary,.pink .bbtn{
    background-color:#e93e70!important;
}

#pink .btn-pink{
background-color: #f680a0!important;
}

.blue.header {
    background-color: #3e7ebc !important;
  }
  .pink.header {
    background-color: #f680a0 !important;
  }
#bobd .MuiInputBase-formControl{
    border-radius: 10px !important;
    margin-top:2px;
}
.no_app{
    min-height: 50%;
}
.css-1hn9ihz-MuiFormHelperText-root.Mui-error {
    color: #ff1744;
}`, "",{"version":3,"sources":["webpack://./src/pages/mobileview/style.css"],"names":[],"mappings":"AACA;IACI,yDAAmE;IACnE,aAAa;IACb,WAAW;AACf;AACA;IACI,yDAAwE;IACxE,aAAa;IACb,WAAW;AACf;;CAEC;;IAEG;AACJ;IACI,UAAU;IACV,eAAe;IACf,gDAAgD;IAChD,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;;;;;;;GAOG;;AAEH;IACI,gDAAgD;IAChD,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gDAAgD;AACpD;AACA;AACA,oCAAoC;AACpC,WAAW;AACX,yBAAyB;AACzB,gDAAgD;AAChD,4BAA4B;AAC5B,qCAAqC;AACrC;AACA;IACI,6BAA6B;IAC7B,yBAAyB;AAC7B,gDAAgD;AAChD,4BAA4B;;AAE5B;AACA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,gDAAgD;AACpD,4BAA4B;AAC5B,qBAAqB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,gDAAgD;AACpD;AACA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,0BAA0B;IAC1B,gDAAgD;AACpD;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,gDAAgD;IAChD,4BAA4B;IAC5B;AACJ;IACI,yBAAyB;IACzB,gDAAgD;IAChD,4BAA4B;;AAEhC;AACA;IACI,yBAAyB;IACzB,gDAAgD;IAChD,4BAA4B;AAChC;AACA;IACI,yBAAyB;IACzB,gDAAgD;IAChD,4BAA4B;AAChC;AACA;IACI,2BAA2B;IAC3B,gDAAgD;IAChD,4BAA4B;IAC5B,0CAA0C;IAC1C,YAAY;IACZ,UAAU;AACd;AACA;IACI,2BAA2B;IAC3B,gDAAgD;IAChD,4BAA4B;GAC7B,2CAA2C;IAC1C,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,gDAAgD;IAChD,4BAA4B;IAC5B,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,gDAAgD;AACpD;AACA;IACI,2BAA2B;IAC3B,gDAAgD;AACpD;AACA;IACI,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;AACpD;;;AAGA;IACI,wBAAwB;AAC5B;;;AAGA,sBAAsB;AACtB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yDAAmE;IACnE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,oCAAoC;EACtC;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI;IACA,oEAAwE;IACxE;IACA;YACQ,aAAa;IACrB;AACJ;;;AAGA;IACI,kCAAkC;AACtC;;AAEA;AACA,mCAAmC;AACnC;;AAEA;IACI,oCAAoC;EACtC;EACA;IACE,oCAAoC;EACtC;AACF;IACI,8BAA8B;IAC9B,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;AAClB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap');\n.blue_bg{\n    background-image: url(../../assets/images/mobile/OnboardScreen.png);\n    height: 340px;\n    width: 100%;\n}\n.pink .blue_bg{\n    background-image: url(../../assets/images/mobile/pink/OnboardScreen.png);\n    height: 340px;\n    width: 100%;\n}\n\n /* nav.navbar {\n    display: none;\n}  */\n.app_logo{\n    color:#fff;\n    font-size: 26px;\n    font-family: 'Montserrat', sans-serif !important;\n    font-weight: 700;\n    margin-top: 10px;\n    text-align: center;\n}\n/* .loginpage {\n    font-family: 'Montserrat', sans-serif !important;\n    margin-top: -88px;\n    width: 100%;\n    margin-left: -11px;\n    margin-right: -11px;\n    position: absolute;\n} */\n\n.loginpage {\n    font-family: 'Montserrat', sans-serif !important;\n    width: 100%;\n    position: absolute;\n} \n\n.login_form p{\n    font-family: 'Montserrat', sans-serif !important;\n}\n.mvbutton{\nbackground-color: #4565AD !important;\nheight:60px;\nfont-size: 20px!important;\nfont-family: 'Montserrat', sans-serif !important;\nfont-weight: 600  !important;\ntext-transform: capitalize !important;\n}\n.mobile_inp{\n    text-align: center !important;\n    font-size: 18px!important;\nfont-family: 'Montserrat', sans-serif !important;\nfont-weight: 500  !important;\n\n}\n.mobile_inp input.MuiOutlinedInput-input{\n    text-align: center !important;\n    font-size: 18px!important;\n    font-family: 'Montserrat', sans-serif !important;\nfont-weight: 700  !important;\ncolor:#000 !important;\n}\n.login_form {\n    border-radius: 30px;\n}\n.mdfixed-top {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 1030;\n}\n\n.plisttext{\n    font-weight: 700 !important;\n    font-size: 18px !important;\n    padding-top:11px !important;\n    font-family: 'Montserrat', sans-serif !important;\n}\n.patientslist .MuiListItemText-primary{\n    text-transform: uppercase !important;\n    font-weight: 700 !important;\n    font-size: 13px !important;\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.editbutton{\n    background-color: #4565AD !important;   \n    font-size: 10px!important;\n    font-family: 'Montserrat', sans-serif !important;\n    font-weight: 600  !important;\n    }\n.no-text{  \n    font-size: 16px!important;\n    font-family: 'Montserrat', sans-serif !important;\n    font-weight: 500  !important;  \n\n}\n.edit-form-label{\n    font-size: 16px!important;\n    font-family: 'Montserrat', sans-serif !important;\n    font-weight: 600  !important;  \n}\n.sinput-border{\n    font-size: 16px!important;\n    font-family: 'Montserrat', sans-serif !important;\n    font-weight: 500  !important;  \n}\n.bbtn{\n    text-transform:'capitalize';\n    font-family: 'Montserrat', sans-serif !important;\n    font-weight: 600  !important;  \n    /* background-color: #4565AD !important; */\n    height: 50px;\n    color:#fff;\n}\n.cbtn{\n    text-transform:'capitalize';\n    font-family: 'Montserrat', sans-serif !important;\n    font-weight: 600  !important;  \n   /* background-color: #D9D9D9  !important; */\n    /* color:#000 !important; */\n    height: 50px !important;\n}\n\n.blueheader{\n    background-color: #4565AD;\n    color:#fff;\n    margin: -10px;\n    border-radius: 10px 10px 0px 0px;\n}\n\n.blueheader p{\n    color:#fff;\n    font-family: 'Montserrat', sans-serif !important;\n    font-weight: 500  !important;  \n    font-size: 16px!important;\n    padding-top: 10px;\n    margin-bottom: 9px;\n}\n\n.in_bluerow{\n    padding: 5px 10px;\n}\n\n.mgenter_class .MuiFormControlLabel-root{\n    margin-right: 5px !important;\n    font-family: 'Montserrat', sans-serif !important;\n}\n.mgenter_class{\n    margin-left: 0px !important;\n    font-family: 'Montserrat', sans-serif !important;\n}\n.mgenter_class .MuiFormControlLabel-label,#datein{\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n.editpatientslist .MuiFormHelperText-root,.addpatientslist.MuiFormHelperText-root{\n    font-family: 'Montserrat', sans-serif !important;\n}\n\n\n.mgenter_class .css-rgrmo-MuiButtonBase-root-MuiRadio-root.Mui-checked {\n    color:#4565AD !important;\n}\n\n\n/* Splash screen css */\n.splash-screen {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: #ffffff;\n    background-image: url(../../assets/images/mobile/OnboardScreen.png);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n    transition: opacity 0.5s ease-in-out;\n  }\n  \n  .splash-screen.hidden {\n    opacity: 0;\n    visibility: hidden;\n  }\n  \n  .splash-screen.visible {\n    opacity: 1;\n    visibility: visible;\n  }\n.sp_loader{\n    position:absolute;\n    margin-top: 100px;\n}\n@media (max-width: 980px) {\n    .mdfixed-top{\n    background-image: url(../../assets/images/mobile/mheader.png) !important;\n    }\n    .css-1g7nc1s-MuiPickersLayout-root .MuiPickersLayout-actionBar {\n            display: none;\n    }\n}\n\n\n#pink .btn-primary,.pink .bbtn{\n    background-color:#e93e70!important;\n}\n\n#pink .btn-pink{\nbackground-color: #f680a0!important;\n}\n\n.blue.header {\n    background-color: #3e7ebc !important;\n  }\n  .pink.header {\n    background-color: #f680a0 !important;\n  }\n#bobd .MuiInputBase-formControl{\n    border-radius: 10px !important;\n    margin-top:2px;\n}\n.no_app{\n    min-height: 50%;\n}\n.css-1hn9ihz-MuiFormHelperText-root.Mui-error {\n    color: #ff1744;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
